import { FunnelInitialStateType } from "../types/initialStateTypes";

export const initialState: FunnelInitialStateType = {
  funnelsList: undefined,
  funnelWithFunnelStepsWithRelatedEntities: undefined,
  funnelWithFunnelStepsWithoutRelatedEntities: undefined,
};
